import axios from "axios";
import Config from "../../../config";

const v2_actionDeletarCrmSource = (id) => {
    return axios({
        method: "delete",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/sources/${id}/deletar`
    });
};

export default v2_actionDeletarCrmSource;
